// import { Bell, User, Settings, LogOut } from "lucide-react";
// import { useEffect, useState } from "react";
// import Logo from "../components/common/Logo";

// const FrameComponent = () => {
//   const [user, setUser] = useState(null);

//   useEffect(() => {
//     const storedUser = localStorage.getItem("user");

//     if (storedUser) {
//       const parsedUser = JSON.parse(storedUser);
//       setUser(parsedUser);
//     }
//   }, []);

//   const handleLogout = () => {
//     localStorage.removeItem("token");
//     localStorage.removeItem("user");
//     window.location.href = "/";
//   };

//   return (
//     <div className="bg-secondary border-b border-black/5 md:rounded-xl md:shadow-card px-4 py-3 md:p-4">
//       <div className="md:hidden flex items-start justify-between gap-4">
//         <div className="shrink-0">
//           <Logo />
//         </div>

//         <div className="flex flex-col items-end gap-3 min-w-0">
//           <div className="flex items-start gap-2 text-right min-w-0">
//             <img
//               className="w-10 h-10 rounded-full object-cover shrink-0"
//               src="/g1.jpg"
//               alt="Profile"
//             />

//             <div className="min-w-0">
//               <p className="text-sm font-semibold truncate">
//                 Hi, {user?.userID ? user.userID.split("@")[0] : "User"}
//               </p>
//               <p className="text-[11px] text-gray-500 truncate">
//                 Student ID: {user?.uuid || "-"}
//               </p>
//             </div>
//           </div>

//           <div className="flex items-center gap-3 text-primary">
//             <button type="button" aria-label="Notifications" title="Notifications" className="group relative">
//               <Bell className="w-5 h-5" />
//               <span className="pointer-events-none absolute right-0 top-full mt-2 whitespace-nowrap rounded-md bg-gray-900 px-2 py-1 text-[10px] text-white opacity-0 shadow-sm transition group-hover:opacity-100 group-focus-visible:opacity-100">
//                 Notifications
//               </span>
//             </button>

//             <button type="button" aria-label="Profile" title="Profile" className="group relative">
//               <User className="w-5 h-5" />
//               <span className="pointer-events-none absolute right-0 top-full mt-2 whitespace-nowrap rounded-md bg-gray-900 px-2 py-1 text-[10px] text-white opacity-0 shadow-sm transition group-hover:opacity-100 group-focus-visible:opacity-100">
//                 Profile
//               </span>
//             </button>

//             <button type="button" aria-label="Settings" title="Settings" className="group relative">
//               <Settings className="w-5 h-5" />
//               <span className="pointer-events-none absolute right-0 top-full mt-2 whitespace-nowrap rounded-md bg-gray-900 px-2 py-1 text-[10px] text-white opacity-0 shadow-sm transition group-hover:opacity-100 group-focus-visible:opacity-100">
//                 Settings
//               </span>
//             </button>

//             <button
//               type="button"
//               onClick={handleLogout}
//               aria-label="Logout"
//               title="Logout"
//               className="group relative"
//             >
//               <LogOut className="w-5 h-5" />
//               <span className="pointer-events-none absolute right-0 top-full mt-2 whitespace-nowrap rounded-md bg-gray-900 px-2 py-1 text-[10px] text-white opacity-0 shadow-sm transition group-hover:opacity-100 group-focus-visible:opacity-100">
//                 Logout
//               </span>
//             </button>
//           </div>
//         </div>
//       </div>

//       <div className="hidden md:flex items-start justify-between gap-6">
//         <div className="flex flex-col items-start">
//           <Logo />
//         </div>

//         <div className="flex items-start gap-3 ml-auto">
//           <img
//             className="w-12 h-12 rounded-full object-cover shrink-0"
//             src="/g1.jpg"
//             alt="Profile"
//           />

//           <div className="text-sm leading-6 text-left">
//             <p className="font-semibold text-black">
//               Hi, {user?.userID ? user.userID.split("@")[0] : "User"}
//             </p>
//             <p className="text-gray-500">Student ID: {user?.uuid || "-"}</p>
//             <p className="text-gray-500">Batch: {user?.sessionId || "-"}</p>
//             <p className="text-gray-500">Role: {user?.role || "-"}</p>
//             <p className="text-gray-500">Subscription: {user?.subscription || "N/A"}</p>
//           </div>

//           <div className="flex items-center gap-5 text-primary shrink-0 pl-3">
//             <Bell className="icon" />
//             <User className="icon" />
//             <Settings className="icon" />
//             <LogOut className="icon cursor-pointer" onClick={handleLogout} />
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default FrameComponent;


import { Bell, User, LogOut } from "lucide-react";
import { useEffect, useState } from "react";
import Logo from "../components/common/Logo";
import { getStudentProfile } from "../lib/StudentProfileApi";

const FrameComponent = () => {
  const [user, setUser] = useState(null);
  const [profile, setProfile] = useState(null);
  const [profileOpen, setProfileOpen] = useState(false);
  const [profileLoading, setProfileLoading] = useState(false);
  const [profileError, setProfileError] = useState("");

  // =========================================================
  // EXISTING USER/API DATA LOGIC - NO CHANGE
  // =========================================================
  useEffect(() => {
    const storedUser = localStorage.getItem("user");

    if (storedUser) {
      try {
        const parsedUser = JSON.parse(storedUser);
        setUser(parsedUser);
      } catch (error) {
        console.error("Invalid user data:", error);
      }
    }
  }, []);

  // =========================================================
  // LOGOUT - EXISTING LOGIC
  // =========================================================
  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    window.location.href = "/";
  };

  // =========================================================
  // USER NAME
  // =========================================================
  const userName = user?.userID
    ? user.userID.split("@")[0]
    : "User";

  const handleProfileOpen = async () => {
    setProfileOpen(true);
    if (profile || profileLoading) return;

    try {
      setProfileLoading(true);
      const userId = user?.userID || user?.result?.userID || user?.userId || user?.id;
      const data = await getStudentProfile(userId);
      setProfile(data);
    } catch (error) {
      setProfileError(error?.response?.data?.message || error.message || "Unable to load profile");
    } finally {
      setProfileLoading(false);
    }
  };

  const profileName = [profile?.FirstName, profile?.LastName].filter(Boolean).join(" ") || userName;
  const profileInitials = profileName.split(" ").map((part) => part[0]).join("").slice(0, 2).toUpperCase();

  return (
    <header
      className="
        w-full
        bg-secondary
        box-border
        overflow-hidden
      "
    >
      {/* =====================================================
          MAIN HEADER
          ===================================================== */}

      <div
        className="
          w-full
          box-border

          px-[18px]
          sm:px-[22px]
          md:px-[28px]
          lg:px-[32px]

          pt-[26px]
          sm:pt-[28px]
          md:pt-[30px]

          pb-[22px]
          sm:pb-[24px]
          md:pb-[26px]

          flex
          flex-col

          lg:flex-row
          lg:items-start
          lg:justify-between

          gap-[24px]
          lg:gap-[30px]
        "
      >
        {/* ===================================================
            LOGO
            =================================================== */}

        <div
          className="
            shrink-0
            flex
            items-start
          "
        >
          <Logo />
        </div>

        {/* ===================================================
            USER AREA
            =================================================== */}

        <div
          className="
            w-full
            lg:w-auto

            flex
            flex-col

            sm:flex-row
            sm:items-center

            gap-[18px]
            sm:gap-[24px]
            lg:gap-[28px]

            lg:ml-auto
          "
        >
          {/* =================================================
              PROFILE INFORMATION
              ================================================= */}

          <div
            className="
              flex
              items-start

              gap-[14px]
              sm:gap-[16px]

              min-w-0
            "
          >
            {/* Avatar */}

            <div
              className="
                w-[54px]
                h-[54px]

                sm:w-[56px]
                sm:h-[56px]

                md:w-[58px]
                md:h-[58px]

                rounded-full

                bg-[#4338CA]

                text-white

                flex
                items-center
                justify-center

                shrink-0

                font-semibold

                text-[19px]
                sm:text-[20px]
              "
            >
              {user?.userID
                ? user.userID
                  .split("@")[0]
                  .slice(0, 2)
                  .toUpperCase()
                : "US"}
            </div>

            {/* User Details */}

            <div
              className="
                min-w-0
                flex
                flex-col
              "
            >
              {/* Name */}

              <p
                className="
                  text-[#11145A]

                  text-[16px]
                  sm:text-[17px]
                  md:text-[18px]

                  font-medium

                  leading-[1.25]

                  whitespace-nowrap
                "
              >
                Hi, {userName}
              </p>

              {/* Student ID */}

              <p
                className="
                  text-[#7B7C9C]

                  text-[14px]
                  sm:text-[15px]

                  font-mono

                  leading-[1.45]

                  whitespace-nowrap
                "
              >
                UserID: {user?.uuid || "-"}
              </p>

              {/* Batch */}

              <p
                className="
                  text-[#7B7C9C]

                  text-[14px]
                  sm:text-[15px]

                  font-mono

                  leading-[1.45]

                  whitespace-nowrap
                "
              >
                Batch: {user?.sessionId || "-"}
              </p>

 <p
                className="
                  text-[#7B7C9C]

                  text-[14px]
                  sm:text-[15px]

                  font-mono

                  leading-[1.45]

                  whitespace-nowrap
                "
              >
                Role: {user?.role || "-"}
              </p>


              {/* Subscription */}

              {/* <p
                className="
                  text-[#00856A]

                  text-[14px]
                  sm:text-[15px]

                  font-mono

                  leading-[1.45]

                  whitespace-normal
                "
              >
                Subscription: {user?.subscription || "N/A"}
              </p> */}
            </div>
          </div>

          {/* =================================================
              ACTION BUTTONS
              ================================================= */}

          <div
            className="
              flex
              items-center

              gap-[10px]
              sm:gap-[12px]

              shrink-0
            "
          >
            {/* Renew */}

            {/* <button
              type="button"
              className="
                h-[42px]

                px-[18px]
                sm:px-[20px]

                rounded-full

                bg-white

                border
                border-[#E1D7C5]

                shadow-sm

                text-[#11145A]

                text-[15px]
                sm:text-[16px]

                font-medium

                whitespace-nowrap

                hover:bg-[#FAF8F3]

                transition
              "
            >
              Renew
            </button> */}

            {/* Notification */}

            {/* <button
              type="button"
              aria-label="Notifications"
              title="Notifications"
              className="
                relative

                w-[44px]
                h-[44px]

                rounded-full

                bg-white

                border
                border-[#E1D7C5]

                flex
                items-center
                justify-center

                text-[#F59E0B]

                shadow-sm

                hover:bg-[#FAF8F3]

                transition

                shrink-0
              "
            > */}
              {/* <Bell
                className="w-[21px] h-[21px]"
                strokeWidth={2}
              /> */}

              {/* Notification Count */}

              {/* <span
                className="
                  absolute

                  -top-[7px]
                  -right-[3px]

                  min-w-[20px]
                  h-[20px]

                  px-[5px]

                  rounded-full

                  bg-[#D94A38]

                  text-white

                  text-[11px]

                  font-semibold

                  flex
                  items-center
                  justify-center
                "
              >
                3
              </span>
            </button> */}

            {/* Profile */}

            <button
              type="button"
              onClick={handleProfileOpen}
              aria-label="Profile"
              title="Profile"
              className="
                w-[44px]
                h-[44px]

                rounded-full

                bg-white

                border
                border-[#E1D7C5]

                flex
                items-center
                justify-center

                 text-[#3f35c7]

                shadow-sm

                hover:bg-[#FAF8F3]

                transition

                shrink-0
              "
            >
              <User
                className="w-[21px] h-[21px]"
                strokeWidth={2}
              />
            </button>

            {/* Logout */}

            <button
              type="button"
              onClick={handleLogout}
              aria-label="Logout"
              title="Logout"
              className="
                w-[44px]
                h-[44px]

                rounded-full

                bg-white

                border
                border-[#E1D7C5]

                flex
                items-center
                justify-center

                text-[#3f35c7]

                shadow-sm

                hover:bg-[#FAF8F3]

                transition

                shrink-0
              "
            >
              <LogOut
                className="w-[21px] h-[21px]"
                strokeWidth={2}
              />
            </button>
          </div>
        </div>
      </div>

      {profileOpen && (
        <div className="fixed inset-0 z-[100] flex items-center justify-center bg-[#211b4e]/45 p-4" onClick={() => setProfileOpen(false)}>
        <div className="max-h-[90vh] w-full max-w-[520px] overflow-y-auto rounded-2xl bg-[#f7f3ea] p-5 shadow-2xl sm:p-7" onClick={(event) => event.stopPropagation()}>
          <div className="mb-5 flex items-start justify-between gap-4">
            <div>
              <p className="text-[10px] font-bold uppercase tracking-[.12em] text-[#8b84a3]">User profile</p>
              <h2 className="mt-1 text-2xl font-extrabold text-[#3f35c7]">Your details</h2>
            </div>
            <button type="button" onClick={() => setProfileOpen(false)} className="grid h-9 w-9 place-items-center rounded-full bg-white text-xl text-[#716a88] hover:text-[#3f35c7]" aria-label="Close profile">×</button>
          </div>

          {profileLoading && <p className="rounded-xl bg-white p-7 text-center text-sm text-[#716a88]">Loading profile…</p>}
          {profileError && <p className="rounded-xl bg-white p-7 text-center text-sm text-[#a8442b]">{profileError}</p>}
          {!profileLoading && !profileError && profile && (
            <>
              <div className="flex items-center gap-4 rounded-2xl bg-[#3f35c7] p-5 text-white">
                {profile.Photo || profile.ProfileUrl ? <img className="h-16 w-16 rounded-full object-cover" src={profile.Photo || profile.ProfileUrl} alt={profileName} /> : <div className="grid h-16 w-16 place-items-center rounded-full bg-[#655bd4] text-xl font-extrabold">{profileInitials}</div>}
                <div className="min-w-0"><h3 className="truncate text-xl font-extrabold">{profileName}</h3><p className="mt-1 text-sm capitalize text-[#e9e7ff]">{profile.RoleName || "Student"}</p><p className="mt-2 truncate text-xs text-[#e9e7ff]">{profile.SchoolName || "School not available"}</p></div>
              </div>
              <div className="mt-4 grid grid-cols-1 gap-3 rounded-2xl bg-white p-5 text-sm sm:grid-cols-2">
                <ProfileValue label="Email" value={profile.EmailId} />
                <ProfileValue label="Mobile" value={profile.MobileNumber} />
                <ProfileValue label="Class" value={profile.UserClasses?.map((item) => item.classname).join(", ")} />
                <ProfileValue label="Subject" value={profile.UserSubjects?.map((item) => item.SubjectName).join(", ")} />
                <ProfileValue label="Gender" value={profile.Gender} />
                <ProfileValue label="Role" value={profile.RoleName} />
                {/* <ProfileValue label="Admission no." value={profile.AdmissionNumber} /> */}
              </div>
            </>
          )}
        </div>
        </div>
      )}
    </header>
  );
};

const ProfileValue = ({ label, value }) => (
  <div className="min-w-0 border-b border-[#eee7dc] pb-2 last:border-0">
    <p className="text-[10px] font-bold uppercase tracking-wide text-[#8b84a3]">{label}</p>
    <p className="mt-1 truncate font-semibold text-[#211b4e]">{value || "Not provided"}</p>
  </div>
);

export default FrameComponent;
